import styles from "./Footer.module.css";

export const Footer = (): JSX.Element => {
  const year: number = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <span className={styles.wordmark}>
            <span>zero</span>
            <span className={styles.wordmarkBracket}>[</span>
            <span className={styles.wordmarkRed}>to</span>
            <span className={styles.wordmarkBracket}>]</span>
            <span>claw</span>
          </span>
          <span className={styles.tagline}>
            Managed OpenClaw instances. Yours, end-to-end.
          </span>
        </div>

        <span className={styles.copyright}>© {year} ZeroToClaw</span>
      </div>
    </footer>
  );
};
